module.exports = __webpack_public_path__ + "40373ea48a4ee9397ad57eb3501ea700.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/twitter-grey.png
// module id = 998
// module chunks = 2